import React from "react";
import { useTranslation } from "react-i18next";
import useLanguage from "../../../utils/useLanguage";
import { formatDate } from "../../../utils/toDate";

const PrintableProductOrderView = React.forwardRef(
  ({ data, currency, orderDetails }, ref) => {
    const { currentDirection } = useLanguage();
    const { t } = useTranslation("general");

    const {
      orderNumber = "",
      date = new Date().toLocaleDateString(),
      companyName = "",
      notes = "",
      createdBy = "",
    } = orderDetails || {};

    console.log(orderDetails)

    // Transform the grouped data structure into flat structure for printing
    const allProducts =
      data?.reduce((acc, category) => {
        category.books.forEach((product) => {
          acc.push({
            ...product,
            categoryName: category.category,
          });
        });
        return acc;
      }, []) || [];

    // Group products by category for display
    const groupedProducts = data || [];

    return (
      <div
        ref={ref}
        className="printable-order-view"
        dir={currentDirection}
        style={{ display: "none" }}
      >
        <section className="print-first-section">
          <div className="u-margin--bottom_500">
            <h1 className="headerTitle">{t("productOrderList")}</h1>
          </div>

          {/* Order information section */}
          <div className="print-info-section">
            <div className="print-info-row">
              <div className="print-info-block">
                <div className="print-info-item">
                  <strong>{t("Date")}:</strong> {formatDate(date)}
                </div>
                <div className="print-info-item">
                  <strong>{t("orderNumber")}:</strong> {orderNumber}
                </div>
              </div>
              <div className="print-info-block">
                <div className="print-info-item">
                  <strong>{t("organizationName")}:</strong> {companyName}
                </div>
                  <div className="print-info-item">
                    <strong>{t("creator")}:</strong> {createdBy}
                  </div>
              </div>
            </div>
          </div>

          {/* Grouped product items */}
          {groupedProducts.map((group) => (
            <div key={group.id} className="print-paper-group">
              <table className="print-fabric-table">
                <thead>
                  <tr>
                    <th>{t("productName")}</th>
                    <th>{t("academicLevel")}</th>
                    <th>{t("productSubType")}</th>
                    <th>
                      {t("quantity")} ({t("book")})
                    </th>
                    <th>
                      {t("singlePrice")} ({currency?.value || "IQD"})
                    </th>
                    <th>
                      {t("totalPrice")} ({currency?.value || "IQD"})
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {group.books.map((product, index) => (
                    <tr key={index}>
                      <td>{product.name}</td>
                      <td>{product.academicLevel}</td>
                      <td>{product.productSubType}</td>
                      <td>{product.quantity}</td>
                      <td>{product.price || ""}</td>
                      <td>{product.totalPrice || ''}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ))}
        </section>

        <section className="print-notes-section">
          <h2>{t("notes")}: </h2>
          <p>{notes}</p>
        </section>

        <section className="print-footer u-margin--top_auto">
          <p className="t-headline-3">{t("ehsiblySecondSlogan")}</p>
          <p>{t("alhabbarSlogan")}</p>
        </section>
      </div>
    );
  }
);

export default PrintableProductOrderView;
